import * as Sentry from "@sentry/nextjs";
import {NextPage} from "next";
import {Trans, useTranslation} from "@i18n/client";
import React, {useEffect, useState} from "react";
import {LeverJobPostingResponse} from "src/_services/types";
import {LEVER_URI} from "src/components/_common/_constants";
import AboutUs from "src/components/v5/About/AboutUs";
import CareersSection from "src/components/v5/About/Careers";
import CoreValues from "src/components/v5/About/CoreValues";
import Hero from "src/components/v5/About/Hero";
import OurBenefits from "src/components/v5/Careers/OurBenefits";
import {IllustratedTextDecoration} from "src/components/v5/IllustratedTextDecoration";
import Layout from "src/components/v5/Layout";

import {FraudAlert} from "../components/v5/Careers/FraudAlert";
import {NavTheme} from "../components/v5/Nav/useNavState";
import {localeServerSideProps} from "@i18n/pages";

const Careers: NextPage = () => {
  const i18n = useTranslation();
  const [jobs, setJobs] = useState<LeverJobPostingResponse[]>([]);

  useEffect(() => {
    fetch(LEVER_URI)
      .then(res => res.json())
      .catch(err => {
        Sentry.captureException(err);
        return [];
      })
      .then(list => {
        setJobs(list);
      });
  }, []);

  const subheader = (
    <Trans>
      We're on a mission to make world-class healthcare accessible{" "}
      <span className="pos-r zIndex1">
        for all.
        <IllustratedTextDecoration type="double-yellow-underline" />
      </span>
    </Trans>
  );

  const caption = (
    <div className="white df fdc aife font-ir lh13">
      <div className="font-ib">Justin</div>
      <div>{i18n.t("Regional Clinical Director")}</div>
      <div>{i18n.t("Southern California")}</div>
    </div>
  );
  return (
    <Layout
      pageTitle={i18n.t("Take The Next Step in Your Career With Carbon Health")}
      pageDescription={i18n.t(
        "Looking for a new career opportunity? Explore all the jobs available at Carbon Health. Let’s work together to make high-quality healthcare accessible to all.",
      )}
      ogAlt={i18n.t("Carbon Health is making good health accessible to everyone. Join us.")}
      pageImage="join-us"
      navTheme={NavTheme.LIGHT}
    >
      <Hero
        h1={i18n.t("Come work with us")}
        subheader={subheader}
        jobCount={jobs.length}
        src="/static/img/v5/careers/justin.jpg"
        alt={i18n.t("Photo of Justin, one of our staff members, standing outside smiling.")}
        caption={caption}
        objectPosition="70% 50%"
        hideGradient
      />

      {jobs.length > 0 && <CareersSection jobs={jobs} />}

      <AboutUs hideStory />
      <OurBenefits />
      <CoreValues />
      <FraudAlert />
    </Layout>
  );
};

export const getServerSideProps = localeServerSideProps();

export default Careers;
